import React from 'react';
import PropTypes from 'prop-types';
import DropdownButton from 'react-bootstrap/lib/DropdownButton';
import MenuItem from 'react-bootstrap/lib/MenuItem';
import { injectIntl } from 'react-intl';
import intlShape from '@/shared/utils/intlShape';
import messages from '../taskMessages';

const TaskGlobalActionsButton = props => {
  const {
    intl,
    disabled,
    onChangeTaskStatus,
    onChangeSubtaskDeadline,
    onNewRegistration,
    onChangeMainTaskField,
    onSendEmail,
    onDeleteTask,
    onResetDeadline,
    onGenerateDocuments,
    onAddTaskTags,
    onRemoveTaskTags,
  } = props;

  return (
    <span
      className="tool-tip"
      data-toggle="tooltip"
      data-placement="top"
      title={disabled ? intl.formatMessage(messages.TaskGlobalActionsTooltip) : ''}
    >
      <DropdownButton
        bsSize="xsmall"
        bsStyle="default"
        className="btn-inverse"
        id="global-actions-button"
        disabled={disabled}
        pullRight
        title={intl.formatMessage(messages.GlobalActions)}
      >
        <MenuItem onSelect={onChangeMainTaskField} disabled={disabled}>
          {intl.formatMessage(messages.ChangeMainTaskField)}
        </MenuItem>
        <MenuItem onSelect={onChangeTaskStatus} disabled={disabled}>
          {intl.formatMessage(messages.ChangeTaskStatus)}
        </MenuItem>
        <MenuItem onSelect={onResetDeadline} disabled={disabled}>
          {intl.formatMessage(messages.ResetDeadline)}
        </MenuItem>
        <MenuItem onSelect={onChangeSubtaskDeadline} disabled={disabled}>
          {intl.formatMessage(messages.ChangeSubtaskDeadline)}
        </MenuItem>
        <MenuItem onSelect={onNewRegistration} disabled={disabled}>
          {intl.formatMessage(messages.NewRegistration)}
        </MenuItem>
        <MenuItem onSelect={onSendEmail} disabled={disabled}>
          {intl.formatMessage(messages.SendEmail)}
        </MenuItem>
        <MenuItem onSelect={onGenerateDocuments} disabled={disabled}>
          {intl.formatMessage(messages.GenerateDocuments)}
        </MenuItem>
        <MenuItem onSelect={onDeleteTask} disabled={disabled}>
          {intl.formatMessage(messages.DeleteTask)}
        </MenuItem>
        <MenuItem onSelect={onAddTaskTags} disabled={disabled}>
          {intl.formatMessage(messages.AddTaskTags)}
        </MenuItem>
        <MenuItem onSelect={onRemoveTaskTags} disabled={disabled}>
          {intl.formatMessage(messages.RemoveTaskTags)}
        </MenuItem>
      </DropdownButton>
    </span>
  );
};

TaskGlobalActionsButton.propTypes = {
  intl: intlShape.isRequired,
  disabled: PropTypes.bool,
  onChangeTaskStatus: PropTypes.func.isRequired,
  onChangeSubtaskDeadline: PropTypes.func.isRequired,
  onNewRegistration: PropTypes.func.isRequired,
  onChangeMainTaskField: PropTypes.func.isRequired,
  onGenerateDocuments: PropTypes.func.isRequired,
  onSendEmail: PropTypes.func.isRequired,
  onDeleteTask: PropTypes.func.isRequired,
  onResetDeadline: PropTypes.func.isRequired,
  onAddTaskTags: PropTypes.func.isRequired,
  onRemoveTaskTags: PropTypes.func.isRequired,
};
TaskGlobalActionsButton.defaultProps = {
  disabled: false,
};
export default injectIntl(TaskGlobalActionsButton);
